/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React, { createContext, useContext, useState } from "react";

const TraceFiltersContext = createContext(null);

export const defaultFilters = {
  estatDoctram: "",
  estat: "",
  app: "",
  estatTercers: "",
  reintents: "",
  dataInici: "",
  dataFi: "",
  modalitat: "",
  servei: "",
  idPeticio: "",
  id: null,
  valor: "",
  descErr: "",
};

export function TraceFiltersProvider({ children }) {
  const [filters, setFilters] = useState(defaultFilters);

  const contextValue = {
    filters,
    setFilters,
  };

  return (
    <TraceFiltersContext.Provider value={contextValue}>
      {children}
    </TraceFiltersContext.Provider>
  );
}

export const useTraceFiltersContext = () => {
  const context = useContext(TraceFiltersContext);
  if (!context) {
    throw new Error(
      "useTraceFiltersContext must be used within a TraceFiltersProvider"
    );
  }
  return context;
};
